import { NgModule } from '@angular/core';
import { DeploymentListComponent } from './deployment-list/deployment-list.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { NgSharedModule } from '../shared/ng/ng-shared.module';
import { AngularSharedModule } from '../shared/angularShared/angularShared.module';
import { DesignFactoryModule } from '../shared/designFactory/designFactory.module';
import { FormsModule } from '@angular/forms';
import { DeploymentComponent } from './deployment/deployment.component';
import { StoreModule } from '@ngrx/store';
import { DEPLOYMENT_FEATURE, deploymentReducer } from './store/deployment.reducer';
import { DeploymentService } from './store/deployment.service';
import {
  DeploymentConfirmationModalComponent
} from './deployment-confirmation-modal/deployment-confirmation-modal.component';
import { EffectsModule } from '@ngrx/effects';
import { DeploymentEffects } from './store/deployment.effects';
import { DeploymentHierarchyListComponent } from './deployment-hierarchy-list/deployment-hierarchy-list.component';
import { DfToastModule, DfTooltipModule } from '@design-factory/design-factory';
import { DeploymentOfficesListComponent } from './deployment-offices-list/deployment-offices-list.component';
import { DeploymentSummaryComponent } from './deployment-summary/deployment-summary.component';
import { DeploymentPipesModule } from './pipes/deployment-pipes.module';
import { ConfigurationsPipesModule } from '../configuration/pipes/configurations-pipe.module';
import { InventoryPanelsModule } from '../inventory-panels/inventory-panels.module';

@NgModule({
  declarations: [
    DeploymentListComponent,
    DeploymentComponent,
    DeploymentConfirmationModalComponent,
    DeploymentHierarchyListComponent,
    DeploymentOfficesListComponent,
    DeploymentSummaryComponent,
  ],
  exports: [
    DeploymentComponent
  ],
  imports: [
    DeploymentPipesModule,
    NgSharedModule,
    AngularSharedModule,
    PipesModule,
    DesignFactoryModule,
    FormsModule,
    StoreModule.forFeature(DEPLOYMENT_FEATURE, deploymentReducer),
    EffectsModule.forFeature([DeploymentEffects]),
    DfTooltipModule,
    DfToastModule,
    InventoryPanelsModule,
    ConfigurationsPipesModule,
  ],
  providers: [
    DeploymentService
  ]
})
export class DeploymentsModule {
}
